module.exports = __webpack_public_path__ + "img/0.321d6b7c.jpg";